import React, { Component } from 'react';
import { Route, withRouter } from 'react-router-dom';
import { connect } from 'react-redux'; // eslint-disable-line no-unused-vars
import common from '~/common';
import Bg from './Bg';
import Paper from './Paper';
import Login from './Login';
import LoginDetail from './LoginDetail';
import FogetPsd from './FogetPsd';
import ChangePsd from './ChangePsd';

class App extends Component {
  state={ page: 'Login' }
  componentDidMount () {
  }

  componentDidUpdate (prevProps) {

  }

  render () {
    return (
      <div style={{ width: '100%', height: '100%' }}>
        <Bg />
        <Paper>
          <Route exact path={`${common.rootPath}/Login`} component={Login} />
          <Route exact path={`${common.rootPath}/Login/Detail`} component={LoginDetail} />
          <Route exact path={`${common.rootPath}/Login/FogetPsd`} component={FogetPsd} />
          <Route exact path={`${common.rootPath}/Login/ChangePsd/:token`} component={ChangePsd} />
          <Route exact path={`${common.rootPath}/Login/ActiveAct/:token`} component={ChangePsd} />
          <Route exact path={`${common.rootPath}/Manage/Login`} component={Login} />
          <Route exact path={`${common.rootPath}/Manage/Login/Detail`} component={LoginDetail} />
          <Route exact path={`${common.rootPath}/Manage/Login/FogetPsd`} component={FogetPsd} />
        </Paper>
      </div>
    );
  }
}
const mapStateToProps = state => ({
  session: state.session,
});
const mapDispatchToProps = dispatch => ({
});
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));
